"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var common_1 = require("@angular/common");
var confirm_dialog_module_1 = require("./component/confirm-dialog/confirm-dialog.module");
var form_dialog_module_1 = require("./component/form/form-dialog.module");
var forms_component_module_1 = require("./component/forms/forms-component.module");
var form_management_routing_1 = require("./form-management.routing");
var form_pipes_module_1 = require("./pipe/form-pipes.module");
var form_management_service_1 = require("./service/form-management.service");
var form_management_http_service_1 = require("./service/form-management-http.service");
var material_module_1 = require("../material.module");
var form_dialog_component_1 = require("./component/form/form-dialog.component");
var material_1 = require("@angular/material");
var confirm_dialog_component_1 = require("./component/confirm-dialog/confirm-dialog.component");
var FormManagementModule = /** @class */ (function () {
    function FormManagementModule() {
    }
    FormManagementModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                idm_ng_controls_1.ControlsModule,
                forms_1.FormsModule,
                form_management_routing_1.formManagementRouting,
                material_module_1.MaterialModule,
                material_1.MatDialogModule,
                forms_component_module_1.FormsComponentModule,
                form_dialog_module_1.FormDialogModule,
                confirm_dialog_module_1.ConfirmDialogModule,
                form_pipes_module_1.FormPipesModule
            ],
            exports: [
                form_dialog_module_1.FormDialogModule,
                confirm_dialog_module_1.ConfirmDialogModule,
                form_pipes_module_1.FormPipesModule
            ],
            entryComponents: [
                form_dialog_component_1.FormDialogComponent,
                confirm_dialog_component_1.ConfirmDialogComponent
            ],
            providers: [
                { provide: form_management_service_1.FormManagementService, useClass: form_management_http_service_1.FormManagementHttpService }
            ]
        })
    ], FormManagementModule);
    return FormManagementModule;
}());
exports.FormManagementModule = FormManagementModule;
//# sourceMappingURL=form-management.module.js.map